<div class="d-flex justify-content-end mb-3">
	<div class="search-wrapper">
		<input class="form-control"
		       type="text"
		       placeholder="Search by Group, FGI, or Instance"
		       data-identifier="organization-site-search"
		       [formControl]="searchTermControl">
		<span class="form-control search-icon">
			<i class="fa fa-search"></i>
		</span>
	</div>
</div>